import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-793d6738"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stock" }
const _hoisted_2 = { class: "measure-title" }
const _hoisted_3 = { class: "measureBox" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  style: {"word-break":"break-all"}
}
const _hoisted_6 = { class: "product-img" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "word-break" }
const _hoisted_9 = { class: "flex-ter" }
const _hoisted_10 = {
  key: 0,
  class: "img-box"
}
const _hoisted_11 = { class: "elimg-mask" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "img-count" }
const _hoisted_14 = { class: "flex-ter" }
const _hoisted_15 = { class: "flex productMeasureDtoList" }
const _hoisted_16 = { class: "flex-center" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "flex-center" }
const _hoisted_19 = { class: "el-dialog__body-title" }
const _hoisted_20 = { style: {"padding":"20px","background-color":"#fff"} }
const _hoisted_21 = { style: {"margin-top":"20px","font-size":"16px"} }
const _hoisted_22 = { class: "footer flex-ter-end" }
const _hoisted_23 = { class: "el-dialog__body-title" }
const _hoisted_24 = { style: {"padding":"20px","background-color":"#fff"} }
const _hoisted_25 = { class: "flex" }
const _hoisted_26 = { style: {"width":"200px"} }

import { t } from '@/plugins/i18n'
import { isD2C, useRtfix, isJA, isKO } from '@/store'
import {
  ref,
  reactive,
  nextTick,
  onMounted,
  computed,
  watch,
  toRaw,
  onUnmounted
} from 'vue'
import { QuestionFilled } from '@element-plus/icons-vue'
import STable from '@/components/Table/index.vue'

import MeasureSearch from './MeasureSearch.vue'
import AccessoriesDialog from './AccessoriesDialog.vue'
import BindAmazon from '@/views/inshipping/components/BindAmazon.vue'
import OverseaProductSku from '@/views/inshipping/components/OverseaProductSku.vue'
import CustomerProductMsku from '@/views/inshipping/components/CustomerProductMsku.vue'
import Guide from '@/components/guide/index.vue'
import ChooseSendType from './ChooseSendType/index.vue'
import PreviewImgPopupVue from '@/components/common/PreviewImgPopup.vue'
import {
  d2cproductColumns,
  b2bProductColumns,
  measureColumns,
  groupTableConfig,
  combinationColumns
} from './data'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import ToolList from './ToolList.vue'
import CopyButton from '@/components/common/CopyButton.vue'
import BatchSearch from '@/components/BatchSearch/index.vue'
import useTabData from '@/util/useTabData'
import {
  getStockList,
  getProductList,
  batchAddProduct,
  addIngredientsProduct,
  batchBindAmazonSku,
  getMeasureList,
  getCombinaProductDetailApi
} from '@/apis/stock'
import useMaterialFilter from './useMaterialFilter'
import useProductFilter from './useProductFilter'
import { ElMessage, ElMessageBox } from 'element-plus'
import { setNoEmptyForm, getJapanTime } from '@/util/common'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { syncAllGoods, getLastTime } from '@/apis/associated'
import { confirmApiUnbind } from '@/util/useConfirm'
import { useRequest } from '@/util/useLoading'

import { getCartAmount } from '@/apis/shopcart'
import { setAdt } from '@/util/calcAdt'
import { getCustomerShop, batchQueryCombinationProduct } from '@/apis/order'
import axios from 'axios'
import { exportFileDownload } from '@/util/useExport'
import bus from '@/util/useBus'
import imgnumber from '@/assets/image/img.png'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()

const isAmazon = ref()
const syncTime = ref()
if (!isD2C()) {
  getCustomerShop().then((res: any) => {
    if (res.success) {
      isAmazon.value =
        res.data.customerShopPlatform === 4 && res.data.customerShopAuthStatus
    }
  })

  getLastTime().then((res: any) => {
    if (res.success) {
      syncTime.value = res.data.date
    }
  })
}

const jump = (url: any) => {
  const routerUrl: any = router.resolve(url)
  window.open(routerUrl.href, '_blank')
}

const popverRef: any = ref()
const createType = ref(1)
const sendType = ref(2)
const sendTypeVisible = ref(false)

const creatShipping = () => {
  if (createType.value === 1) {
    router.push(
      useRtfix('CreateReplenishment', {
        query: {
          shopProductSku: (productSelectionList.value.filter(
            (item: any) => item.availableQuantity > 0
          ) || [])
            .map((e: any) => e.shopProductSku)
            .join(',')
        }
      })
    )
  } else {
    // sendTypeVisible.value = true
    chooseCall()
  }
}
const chooseCall = () => {
  console.log(sendType)
  router.push(
    useRtfix('CreateShipping', {
      query: {
        sendType: sendType.value,
        shopProductSku: (productSelectionList.value.filter(
          (item: any) => item.availableQuantity > 0
        ) || [])
          .map((e: any) => e.shopProductSku)
          .join(',')
      }
    })
  )
}

const onClickBindLoading = ref(false)

// const productPageData = ref({
//   page: 1,
//   limit: 30
// })

// const materialsPageData = ref({
//   page: 1,
//   limit: 30
// })

const measurePageData = ref({
  page: 1,
  limit: 30
})
const [mSearchForm, mSortForm, mFilterData] = useMaterialFilter()
const [pSearchForm, pSortForm, pFilterData] = useProductFilter()
const measureForm = ref({})
if (route.query.productSkuOrName) {
  pSearchForm.value.productSkuOrName = route.query.productSkuOrName
}
onMounted(() => {
  refreshTable(true)
  setTimeout(() => {
    store.dispatch('measure/getMeasureNum')
  }, 2000)
})

const createTypeVisible = ref(false)
const store = useStore()
const customerShopName = computed(() => store.getters.shopname)

const rowItem = ref()
const bindAmazonVisible = ref(false)

const [syncLoading, syncApi] = useRequest(syncAllGoods)

const refreshTable = (type?: boolean) => {
  productRef.value && productRef.value && productRef.value.clearSelection && productRef.value.clearSelection()
  if (type) {
    measurePageData.value = {
      page: 1,
      limit: 30
    }
  }
  refreshMeasure()
}

const productRef = ref()

const materialsRef = ref()

const measureRef = ref()
const refreshMeasure = () => {
  console.log(measureRef)
  nextTick(() => {
    measureRef.value && measureRef.value.getData()
  })
}

const materialsFlag = ref(false)

const accessoriesVisible = ref(true)
const { tabData, stock } = useTabData(
  { TabName: 'stock', EmptyTabName: 'product' },
  () => refreshTable(true)
)

const productSelectionList: any = reactive({ value: [] })

const batchProductAddLoading = ref(false)
const materialSelectionList: any = ref([])

const addProduct = (params: any) => {
  return new Promise<void>((resolve, reject) => {
    batchAddProduct(params)
      .then(async (res: any) => {
        if (res.success) {
          resolve()
        } else {
          reject(new Error())
        }
      })
      .catch(() => {
        reject(new Error())
      })
  })
}

const addIngredient = (params: any) => {
  return new Promise<void>((resolve, reject) => {
    addIngredientsProduct(params)
      .then(async (res: any) => {
        if (res.success) {
          resolve()
        } else {
          reject(new Error())
        }
      })
      .catch(() => {
        reject(new Error())
      })
  })
}

const showAddCartInfo = async (len: any) => {
  const amount = await getCartAmount().then((res) => res.data)
  ElMessageBox.confirm(
    `
      <div>${t('X件商品已添加至购物车').replace('X', len)}</div>
      <div>${t('当前购物车共X种商品').replace('X', amount)}</div>
    `,
    t('添加成功'),
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: t('去结算'),
      cancelButtonText: t('留在此页'),
      type: 'success'
    }
  ).then(() => {
    router.push(useRtfix('shopcart'))
  })
}

const showProductRed = ref(true)
const showProductBlue = ref(true)

const b2bPColumns = ref(
  b2bProductColumns.map((e: any) => ({ ...e, hidden: false }))
)

watch(
  () => b2bPColumns.value,
  (val) => {
    showProductRed.value = val.some(
      (e: any) => e?.className?.includes('red-set') && !e.hidden
    )
    showProductBlue.value = val.some(
      (e: any) => e?.className?.includes('blue-set') && !e.hidden
    )
  }
)

watch(
  () => isAmazon.value,
  (val) => {
    b2bPColumns.value = b2bPColumns.value.map((e: any) => {
      e?.className?.includes('amazon-set') && (e.hidden = !val)
      return e
    })
  }
)

const exportProductLoading = ref(false)

const batchSearchParams = ref({})
const isBatchSearch = ref(false) // 是否批量搜索
bus.on('batchSearchStock', (params: any) => {
  isBatchSearch.value = true
  batchSearchParams.value = params
  refreshTable(true)
})
const searchForm = () => {
  isBatchSearch.value = false
  refreshTable(true)
}

// 组合商品展开

const tableWidth = ref(0)
onMounted(() => {
  changeTableWidth()
  window.addEventListener('resize', changeTableWidth)
})
onUnmounted(() => {
  window.removeEventListener('resize', changeTableWidth)
})

const changeTableWidth = () => {
  // 计算展开table的宽度
  tableWidth.value = document.querySelector('.product-table')?.clientWidth || 0
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('我的商品测量结果')), 1),
    _createVNode(MeasureSearch, {
      form: measureForm.value,
      "onUpdate:form": [
        _cache[0] || (_cache[0] = ($event: any) => ((measureForm).value = $event)),
        searchForm
      ]
    }, null, 8, ["form"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(STable, {
        ref: (_value, _refs) => {
          _refs['measureRef'] = _value
          measureRef.value = _value
        },
        columns: _unref(measureColumns),
        "page-data": measurePageData.value,
        "onUpdate:page-data": _cache[1] || (_cache[1] = ($event: any) => ((measurePageData).value = $event)),
        filterData: measureForm.value,
        api: _unref(getMeasureList),
        class: "measureTable"
      }, {
        platformOrderNo: _withCtx(({ row }) => [
          _createElementVNode("div", null, [
            (row.platformOrderId)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: _withModifiers(($event: any) => (jump(_unref(useRtfix)('OrderInfo', { params: { id: row.platformOrderId }, query: { type: row.orderSource !== 1 ? 1 : '' } }))), ["stop"]),
                  style: {"word-break":"break-all"}
                }, _toDisplayString(row.platformOrderNo), 9, _hoisted_4))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(row.platformOrderNo), 1))
          ])
        ]),
        productMainImg: _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(ShoppingPreview, {
              image: row.productMainImg || ''
            }, null, 8, ["image"])
          ])
        ]),
        productName: _withCtx(({ row }) => [
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              href: '../goods/' + row.productCode,
              class: "product-name word-break",
              target: "_blank",
              rel: "noopener noreferrer"
            }, _toDisplayString(row.productName), 9, _hoisted_7)
          ])
        ]),
        productSku: _withCtx(({ row }) => [
          _createElementVNode("div", null, _toDisplayString(row.productProp), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(row.productSku), 1)
        ]),
        urls: _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_9, [
            (row.urls)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (row.urls)
                    ? (_openBlock(), _createBlock(_component_el_image, {
                        key: 0,
                        src: row.urls[0],
                        infinite: false,
                        "preview-teleported": true,
                        "preview-src-list": row.urls,
                        fit: "cover"
                      }, null, 8, ["src", "preview-src-list"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("img", {
                      src: _unref(imgnumber),
                      class: "imgnum"
                    }, null, 8, _hoisted_12),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(row.urls.length), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        productMeasureDtoList: _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_scrollbar, {
              style: {"border-radius":"4px"},
              always: true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.productMeasureDtoList, (i, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i.code,
                      class: "measureItem flex-col"
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        _createTextVNode(_toDisplayString(_unref(t)(i.name)) + " ", 1),
                        (index !== row.productMeasureDtoList.length - 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "|"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(i.value), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 2
            }, 1024)
          ])
        ]),
        _: 1
      }, 8, ["columns", "page-data", "filterData", "api"])
    ]),
    (materialsFlag.value)
      ? (_openBlock(), _createBlock(AccessoriesDialog, {
          key: 0,
          visible: accessoriesVisible.value,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((accessoriesVisible).value = $event)),
          title: _unref(t)('辅料绑定提醒')
        }, null, 8, ["visible", "title"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: createTypeVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((createTypeVisible).value = $event)),
      "custom-class": "createTypeVisible",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)("配送")), 1),
        _createElementVNode("div", _hoisted_20, [
          (isAmazon.value)
            ? (_openBlock(), _createBlock(_component_el_radio_group, {
                key: 0,
                modelValue: createType.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((createType).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, { label: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("通过FBA补货计划发货")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("普通发货")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (createType.value === 2)
            ? (_openBlock(), _createBlock(_component_el_radio_group, {
                key: 1,
                modelValue: sendType.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((sendType).value = $event)),
                style: {"padding":"10px 0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, { label: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('乐天')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 3 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('SHOPLIST')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 4 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('ZOZOTOWN')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('其他')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(t)("店铺")) + ": " + _toDisplayString(_unref(customerShopName)), 1),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_el_button, {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (createTypeVisible.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("取消")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: creatShipping
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("确认")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: bindAmazonVisible.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((bindAmazonVisible).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, _toDisplayString(rowItem.value?.amazonBindStatus != 2 ? _unref(t)("绑定") : _unref(t)("换绑")) + _toDisplayString(_unref(t)("Amazon sku")), 1),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(t)("平台")) + " : " + _toDisplayString(_unref(t)("AMAZON")), 1)
          ]),
          _createVNode(BindAmazon, {
            rowItem: rowItem.value,
            "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (bindAmazonVisible.value = false)),
            onSuccess: refreshTable
          }, null, 8, ["rowItem"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ChooseSendType, {
      visible: sendTypeVisible.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((sendTypeVisible).value = $event)),
      "custom-class": "createTypeVisible",
      onChooseCall: chooseCall
    }, null, 8, ["visible"]),
    (_unref(isD2C)())
      ? (_openBlock(), _createBlock(Guide, {
          key: 1,
          name: "d2c-stock-list"
        }))
      : _createCommentVNode("", true),
    _createVNode(BatchSearch, { title: "Stock" })
  ]))
}
}

})